import { Dispatch, ReactElement, SetStateAction } from 'react';

import { CustomDatePicker } from '@/shared/components/molecules';
interface IHeaderProps {
  date: Date;
  setDate: Dispatch<SetStateAction<Date>>;
}
export default function Header({ date, setDate }: IHeaderProps): ReactElement {
  return (
    <section className='flex w-full flex-col items-center justify-between laptop:flex-row'>
      {/* <div className='flex-1'>
        <ChooseAsset />
      </div> */}
      <div className='flex flex-1 justify-center'>
        {/* <div className='translate-x-1/2'> */}
        <div>
          <CustomDatePicker
            defaultDate={date}
            onlyDatePicker
            onChange={setDate}
          />
        </div>
      </div>
    </section>
  );
}
